import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import { trackCxFoundationsSelfServeTopicCsatClick } from "@faire/web-api/events/cxFoundations/click/selfServeTopicCsat";
import { trackCxFoundationsHelpCenterComprehensiveCsatSubmit } from "@faire/web-api/events/cxFoundations/submit/helpCenterComprehensiveCsat";
/**
 * https://www.faire.com/pete/event/cx_foundations-self_serve_topic_csat-click
 */
export var trackCsatClick = function trackCsatClick(brandOrRetailerToken, issue, feedback) {
  trackCxFoundationsSelfServeTopicCsatClick(issue, feedback, brandOrRetailerToken !== null && brandOrRetailerToken !== void 0 ? brandOrRetailerToken : "");
};
/**
 * Collect CSAT information with PETE
 *
 * https://www.faire.com/pete/event/cx_foundations-help_center_comprehensive_csat-submit
 */
export var trackCsatSubmit = function trackCsatSubmit(feedback, checkedReasons, openReason, context) {
  var _context$brandOrderTo;
  var brandToken = getToken(context, "b_");
  var retailerToken = getToken(context, "r_");
  trackCxFoundationsHelpCenterComprehensiveCsatSubmit(context.issue, (_context$brandOrderTo = context.brandOrderToken) !== null && _context$brandOrderTo !== void 0 ? _context$brandOrderTo : "", String(context.isInstantAnswerAvailable), context.suggestedArticles.join(" && "), context.lastVisitedArticle, feedback, checkedReasons.join(" && "), openReason.trim(), brandToken, retailerToken);
};
var getToken = function getToken(context, prefix) {
  var _context$brandOrRetai;
  return (_context$brandOrRetai = context.brandOrRetailerToken) !== null && _context$brandOrRetai !== void 0 && _context$brandOrRetai.startsWith(prefix) ? context.brandOrRetailerToken : "";
};